import { gql } from '@apollo/client';
import { Box, Link, Tooltip, VStack } from '@chakra-ui/react';
import { t } from 'i18next';
import React, { PropsWithChildren } from 'react';
import { CellProps } from 'react-table';
import { ClaimCodeTable_ClaimCodeFragment } from '../__generated__/ClaimCodeTable.graphql';
import {
  DefaultConfigurationCell_ClaimCodeFragment,
  DefaultConfigurationCell_CustomerFragment,
} from './__generated__/DefaultConfigurationCell.graphql';

interface DefaultConfigurationCellProps
  extends PropsWithChildren<CellProps<ClaimCodeTable_ClaimCodeFragment, string>> {
  configurations: DefaultConfigurationCell_CustomerFragment;
  muliClaimId: DefaultConfigurationCell_ClaimCodeFragment;
}

export function DefaultConfigurationCell({
  muliClaimId,
  configurations,
}: DefaultConfigurationCellProps) {
  const multiClaimId = muliClaimId.id;
  const defaultConfigurationList = configurations.multiClaimDefaultConfigurations;
  const defaultConfigs = defaultConfigurationList?.find(
    (config) => config.multiClaimId === multiClaimId,
  );

  const handleConfigurationClick = (configurationId: string, e: React.MouseEvent) => {
    e.preventDefault();
    console.log(`Configuration clicked: ${configurationId}`);
  };

  return (
    <VStack align="start" spacing={1}>
      {defaultConfigs?.defaultConfigurations && defaultConfigs.defaultConfigurations.length > 0 ? (
        defaultConfigs.defaultConfigurations.map((config) => {
          const configDetails = configurations.configurations.find(
            (c) => c.id === config.configurationId,
          );

          return (
            <Tooltip
              key={config.configurationId}
              label={configDetails ? configDetails.name : 'N/A'}
            >
              <Box key={config.configurationId} mb={1}>
                <Link
                  key={config.configurationId}
                  sx={{
                    display: '-webkit-box',
                    WebkitLineClamp: 1,
                    WebkitBoxOrient: 'vertical',
                    overflow: 'hidden',
                    textOverflow: 'ellipsis',
                    maxWidth: '100px',
                  }}
                  color="blue.500"
                  cursor="pointer"
                  _hover={{ textDecoration: 'underline' }}
                  onClick={(e) => handleConfigurationClick(config.configurationId, e)}
                >
                  {configDetails ? configDetails.name : 'N/A'}
                </Link>
              </Box>
            </Tooltip>
          );
        })
      ) : (
        <Link
          color="blue.500"
          cursor="pointer"
          _hover={{ textDecoration: 'underline' }}
          onClick={(e) => handleConfigurationClick('', e)}
        >
          {t('setDefaultMultiClaim')}
        </Link>
      )}
    </VStack>
  );
}

DefaultConfigurationCell.graphql = {
  fragments: {
    DefaultConfigurationCell_claimCode: gql`
      fragment DefaultConfigurationCell_claimCode on MultiClaimCodeDocument {
        id
      }
    `,

    DefaultConfigurationCell_customer: gql`
      fragment DefaultConfigurationCell_customer on Customer {
        id
        handle
        configurations {
          id
          name
          state
          platform
        }
        supportedPlatforms
        multiClaimDefaultConfigurations {
          id
          type
          multiClaimId
          defaultConfigurations {
            platform
            configurationId
          }
        }
      }
    `,
  },
};
